
const invoicesTypes = {
  INVOICES_TABLE_STATE_SET: 'INVOICES/TABLE_STATE_SET',
  INVOICES_TABLE_STATE_RESET: 'INVOICES/TABLE_STATE_RESET',
};
export default invoicesTypes;